export default __webpack_public_path__ + "static/comics-featured-8ee27e4bd6425d5a1ae6e5618b94b90d.png";